import type { ApplicationFormData } from '../types'
import { buildAddressDisplayValue, getInitialFormData } from './storage'

export type InitialApplicationViewState = {
  formData: ApplicationFormData
  fullAddress: string
}

export function getInitialApplicationViewState(): InitialApplicationViewState {
  const formData = getInitialFormData()

  return {
    formData,
    fullAddress: buildAddressDisplayValue(formData)
  }
}
